import { ableToColorize } from './colorValidators';

export function processSvgData(svgText: string, color?: string): string {
    if (!color) return svgText;

    const appliedColor = ableToColorize(color) ? color : '#000000';
    const doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');

    const walker = document.createTreeWalker(doc, NodeFilter.SHOW_ELEMENT, null);
    let node: Element | null = walker.nextNode() as Element;

    while (node) {
        const fillAttr = node.getAttribute('fill');
        const strokeAttr = node.getAttribute('stroke');

        if (fillAttr && ableToColorize(fillAttr)) node.setAttribute('fill', appliedColor);
        if (strokeAttr && ableToColorize(strokeAttr)) node.setAttribute('stroke', appliedColor);

        node = walker.nextNode() as Element;
    }

    const svgAsXML = new XMLSerializer().serializeToString(doc.documentElement);
    return `data:image/svg+xml;base64,${btoa(svgAsXML)}`;
}
